export const dateT = () => {
    let year = new Date().getFullYear()
    let month = new Date().getMonth()+1 < 10 ? '0' + (new Date().getMonth()+1) :  new Date().getMonth()+1
    let Day = new Date().getDate() < 10 ? '0' +(new Date().getDate()) : new Date().getDate()
    let hours = new Date().getHours() < 10 ? '0' +(new Date().getHours()) : new Date().getHours()
    let min = new Date().getMinutes() < 10 ? '0' +(new Date().getMinutes()) : new Date().getMinutes()
    let seconds = new Date().getSeconds() <10 ? '0' +(new Date().getSeconds()) : new Date().getSeconds()
    return `${year}-${month}-${Day} ${hours}:${min}:${seconds}`
}
export const dateOnce = (n) => {
    let year = new Date(n).getFullYear()
    let month = new Date(n).getMonth()+1 < 10 ? '0' + (new Date(n).getMonth()+1) :  new Date(n).getMonth()+1
    let Day = new Date(n).getDate() < 10 ? '0' +(new Date(n).getDate()) : new Date(n).getDate()
    let hours = new Date(n).getHours() < 10 ? '0' +(new Date(n).getHours()) : new Date(n).getHours()
    let min = new Date(n).getMinutes() < 10 ? '0' +(new Date(n).getMinutes()) : new Date(n).getMinutes()
    let seconds = new Date(n).getSeconds() <10 ? '0' +(new Date(n).getSeconds()) : new Date(n).getSeconds()
    return `${year}-${month}-${Day} ${hours}:${min}:${seconds}`
}
export const dataday = (n)=>{
    let year = new Date(n).getFullYear()
    let month = new Date(n).getMonth()+1 < 10 ? '0' + (new Date(n).getMonth()+1) :  new Date(n).getMonth()+1
    let Day = new Date(n).getDate() < 10 ? '0' +(new Date(n).getDate()) : new Date(n).getDate()
    return `${year}-${month}-${Day}`
}
export const datadayChinese = (n)=>{
    let year = new Date(n).getFullYear()
    let month = new Date(n).getMonth()+1 < 10 ? '0' + (new Date(n).getMonth()+1) :  new Date(n).getMonth()+1
    let Day = new Date(n).getDate() < 10 ? '0' +(new Date(n).getDate()) : new Date(n).getDate()
    return `${year}年${month}月${Day}日`
}